
export default {
    '88': {
        receiveLink: process.env.REACT_APP_RECEIVE_LINK_MAIN,
        contractReceiveLink: process.env.REACT_APP_CONTRACT_RECEIVE_LINK_MAIN,
        exploreUrl: process.env.REACT_APP_EXPLORE_URL_MAIN,
        tomoZUrl: process.env.REACT_APP_CONTRACT_TOMOZ_MAIN,
        baseUrl: process.env.REACT_APP_API_BASEURL_MAIN,
        defaultPassword: process.env.REACT_APP_DEFAULT_PASSWORD_MAIN,
        auth: process.env.REACT_APP_AUTH_MAIN,
        env: process.env.REACT_APP_ENV_MAIN,
    },
    '89': {
        receiveLink: process.env.REACT_APP_RECEIVE_LINK,
        contractReceiveLink: process.env.REACT_APP_CONTRACT_RECEIVE_LINK,
        exploreUrl: process.env.REACT_APP_EXPLORE_URL,
        tomoZUrl: process.env.REACT_APP_CONTRACT_TOMOZ,
        baseUrl: process.env.REACT_APP_API_BASEURL,
        defaultPassword: process.env.REACT_APP_DEFAULT_PASSWORD,
        auth: process.env.REACT_APP_AUTH,
        env: process.env.REACT_APP_ENV,
    }
}